import type { NumberConditionFormValues } from "../../../effects-conditions";
import { isTernaryOperator, NumberConditionForm } from "../../../effects-conditions";
import type { randomConditionBuilder } from "./randomConditionBuilder";

// note: these values have been chosen to match up with player
export const RANDOM_RANGE_MIN = 1;
export const RANDOM_RANGE_MAX = 100;

export const RandomConditionEditor: typeof randomConditionBuilder.views.edit = ({
  spec,
  config: { operator, value, value2 },
  onConfigChange,
}) => {
  const initialValues: NumberConditionFormValues = {
    operator: operator ?? "",
    value: value ?? RANDOM_RANGE_MIN,
    value2: value2 ?? RANDOM_RANGE_MAX,
  };

  const handleSubmit = (values: NumberConditionFormValues) =>
    onConfigChange({
      operator: values.operator ? values.operator : undefined,
      value: values.value,
      value2: isTernaryOperator(values.operator) ? values.value2 : undefined,
    });

  return (
    <NumberConditionForm
      {...{
        spec: { ...spec, min: RANDOM_RANGE_MIN, max: RANDOM_RANGE_MAX, formatStringOverrides: formatStrings },
        initialValues,
        onSubmit: handleSubmit,
      }}
    />
  );
};

const formatStrings = {
  description: {
    en: "A number between 1 and 100 will be randomly generated. This value may be evaluated by the condition, thus permitting effects to run based on probability or chance.",
  },
};
